import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'AccessRequestCallback',
  props: {
    uri: {},
    result: {},
    onResult: { type: Function }
  },
  setup(__props: any) {

const props = __props; // access request URI and decision result
if (typeof props.onResult === "function") {
  props.onResult(props.uri, props.result);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, "Access Request has been handled. You are being redirected. Hang on."))
}
}

})